import { Component, DestroyRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEdit } from 'src/app/analytic/model/analyticEdit';

@Component({
  standalone: false,
  selector: 'app-analytic-view',
  templateUrl: './analytic-view.component.html',
  styleUrls: ['./analytic-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnalyticViewComponent implements OnInit
{
  @Input() public id: number;

  public frameHeight = '100vh';
  public url: string;

  constructor(
    private route: ActivatedRoute,
    private readonly destroyRef: DestroyRef,
  )
  {
  }

  public ngOnInit(): void
  {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: { analytic: AnalyticEdit | null }) =>
      {
        if (data.analytic)
        {
          this.id = data.analytic.id;
          this.url = data.analytic.link;
        }
      }
    });
  }

  public onResized(): void
  {
    this.frameHeight = `${window.innerHeight - 120}px`;
  }
}
